import _classCallCheck from "/opt/build/repo/documentation/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { invalidate, addEffect, applyProps } from '@react-three/fiber';
import { Globals as Globals$1 } from '@react-spring/core';
export * from '@react-spring/core';
import { Globals, flushCalls, createStringInterpolator, colors } from '@react-spring/shared';
import { createHost } from '@react-spring/animated';
import * as THREE from 'three';

var batchedUpdates = function batchedUpdates(callback) {
  return callback();
};

var now = function now() {
  return performance.now();
};

var FrameLoop = function FrameLoop(raf) {
  _classCallCheck(this, FrameLoop);

  var idle = true;
  var writing = false;
  var lastTime = 0;
  var currentFrame = [];
  var prevFrame = [];
  var priority = 0;
  var startQueue = new Set();
  var frameQueue = new Set();
  var writeQueue = new Set();

  var start = function start(animation) {
    return currentFrame.indexOf(animation) < 0 && currentFrame.splice(findIndex(currentFrame, function (existing) {
      return existing.priority > animation.priority;
    }), 0, animation);
  };

  var loop = function loop() {
    if (idle) return;
    raf(loop);

    try {
      advance();
    } catch (e) {
      console.error(e);
    }
  };

  var kickoff = function kickoff() {
    if (idle) {
      idle = false;

      if (lastTime == 0) {
        lastTime = now();
        raf(loop);
      }
    }
  };

  var timeoutQueue = [];

  this.setTimeout = function (handler, ms) {
    var time = now() + ms;

    var cancel = function cancel() {
      var index2 = timeoutQueue.findIndex(function (t) {
        return t.cancel == cancel;
      });

      if (index2 >= 0) {
        timeoutQueue.splice(index2, 1);
      }
    };

    var index = findIndex(timeoutQueue, function (t) {
      return t.time > time;
    });
    var timeout = {
      time: time,
      handler: handler,
      cancel: cancel
    };
    timeoutQueue.splice(index, 0, timeout);
    kickoff();
    return timeout;
  };

  var advance = this.advance = function () {
    var time = now();

    if (startQueue.size) {
      startQueue.forEach(start);
      startQueue.clear();
    }

    if (timeoutQueue.length) {
      batchedUpdates(function () {
        var count = findIndex(timeoutQueue, function (t) {
          return t.time > time;
        });
        timeoutQueue.splice(0, count).forEach(function (t) {
          return t.handler();
        });
      });
    }

    if (time > lastTime) {
      var dt = Math.min(64, time - lastTime);
      lastTime = time;
      batchedUpdates(function () {
        if (currentFrame.length) {
          var nextFrame = prevFrame;

          for (var i = 0; i < currentFrame.length; i++) {
            var animation = currentFrame[i];
            priority = animation.priority;

            if (!animation.idle) {
              Globals.willAdvance(animation);
              animation.advance(dt);

              if (!animation.idle) {
                nextFrame.push(animation);
              }
            }
          }

          priority = 0;
          prevFrame = currentFrame;
          prevFrame.length = 0;
          currentFrame = nextFrame;
        }

        flushCalls(frameQueue, time);

        if (writeQueue.size) {
          writing = true;
          flushCalls(writeQueue, time);
          writing = false;
        }
      });
    }
  };

  this.start = function (animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
    } else {
      start(animation);
      kickoff();
    }
  };

  this.onFrame = function (cb) {
    frameQueue.add(cb);
    kickoff();
  };

  this.onWrite = function (cb) {
    if (writing) cb(lastTime);else writeQueue.add(cb);
  };

  if (typeof process !== "undefined" && process.env.NODE_ENV !== "production") {
    var isIdle = function isIdle() {
      return !startQueue.size && !currentFrame.length && !timeoutQueue.length;
    };

    var dispose = function dispose() {
      idle = true;
      startQueue.clear();
      timeoutQueue.length = 0;
    };

    Object.defineProperties(this, {
      _idle: {
        get: isIdle
      },
      _dispose: {
        get: function get() {
          return dispose;
        }
      }
    });
  }
};

function findIndex(arr, test) {
  var index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

var primitives = ["primitive"].concat(Object.keys(THREE).filter(function (key) {
  return /^[A-Z]/.test(key);
}).map(function (key) {
  return key[0].toLowerCase() + key.slice(1);
}));
var frameLoop = new FrameLoop(function () {
  return invalidate();
});
addEffect(function () {
  frameLoop.advance();
  return true;
});
Globals$1.assign({
  createStringInterpolator: createStringInterpolator,
  colors: colors,
  frameLoop: frameLoop
});
var host = createHost(primitives, {
  applyAnimatedValues: applyProps
});
var animated = host.animated;
export { animated as a, animated };